import { render } from "./BienBanApproveButton.vue?vue&type=template&id=1a684a70&ts=true"
import script from "./BienBanApproveButton.vue?vue&type=script&lang=ts"
export * from "./BienBanApproveButton.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__